import React from 'react';
import styles from '../styles/interactive-docs.module.css';

export const AdminScreenWireframe = () => {
    return (
        <div className={styles.wireframeRoot}>
            {/* 1. Минималистичная шапка */}
            <div className={styles.wfHeader}>
                <div className={styles.wfToolbarCenter}>
                    <span className={styles.wfNumTag}>❶</span>
                    <div className={styles.wfModeBadge}>
                        <span className={styles.wfModeText}>Режим: Данные ▾</span>
                    </div>
                    <span className={styles.wfToolBtn}>📏 Линейка</span>
                    <span className={styles.wfToolBtn}>⛶ Площадь</span>
                    <span className={styles.wfToolBtn}>☰ Легенда</span>
                </div>

                <div className={styles.wfHeaderRight}>
                    <div className={styles.wfUserPill}>
                        <span className={styles.wfAvatar}>A</span>
                        <span className={styles.wfUserName}>Админ</span>
                    </div>
                    <span className={styles.wfHeaderIcon}>🚪</span>
                </div>
            </div>

            {/* 2. Рабочее пространство с 1 чистым оранжевым объектом */}
            <div className={styles.wfWorkspace}>
                <div className={styles.wfMapArea}>
                    <svg className={styles.wfMapIsometric} viewBox="0 0 700 320" preserveAspectRatio="xMidYMid slice">
                        {/* Фоновые легкие направляющие */}
                        <path d="M 0 240 L 700 130" stroke="#ffffff" strokeWidth="12" opacity="0.8" />
                        <path d="M 0 240 L 700 130" stroke="#e2e8f0" strokeWidth="6" />

                        {/* Единственный оранжевый участок */}
                        <polygon points="170,160 360,120 330,290 140,260" fill="#f59e0b" fillOpacity="0.4" stroke="#d97706" strokeWidth="2.5" />
                        <text x="210" y="220" fill="#b45309" fontSize="13" fontWeight="700">Участок №15</text>
                    </svg>

                    {/* Нумерация 2: Центральная карта */}
                    <div className={styles.wfMapTag}>
                        <span className={styles.wfNumTag}>❷</span>
                        <span>Интерактивная карта</span>
                    </div>

                    {/* Правая часть: Быстрые действия (3) + Карточка объекта (4) */}
                    <div className={styles.wfRightDock}>
                        {/* 3. Вертикальное быстрое меню */}
                        <div className={styles.wfActionToolbar}>
                            <button className={styles.wfActionBtn} title="Редактировать геометрию">
                                <span className={styles.wfActionIcon}>✏️</span>
                            </button>
                            <button className={`${styles.wfActionBtn} ${styles.wfActionDelete}`} title="Удалить объект">
                                <span className={styles.wfActionIcon}>🗑️</span>
                            </button>
                            <div className={styles.wfActionNumber}>
                                <span className={styles.wfNumTag}>❸</span>
                            </div>
                        </div>

                        {/* 4. Компактная карточка объекта */}
                        <div className={styles.wfPropertyPanel}>
                            <div className={styles.wfPanelTitleRow}>
                                <div className={styles.wfPanelTitleGroup}>
                                    <span className={styles.wfNumTag}>❹</span>
                                    <h4 className={styles.wfPanelTitle}>Настройка объекта</h4>
                                </div>
                            </div>

                            <div className={styles.wfTabsRow}>
                                <span className={`${styles.wfTabItem} ${styles.wfTabActive}`}>Основное</span>
                                <span className={styles.wfTabItem}>Статусы</span>
                                <span className={styles.wfTabItem}>Медиа</span>
                            </div>

                            <div className={styles.wfFormBody}>
                                <div className={styles.wfFormGroup}>
                                    <label className={styles.wfLabel}>Название:</label>
                                    <div className={styles.wfInput}>Участок №15</div>
                                </div>

                                <div className={styles.wfFormGroup}>
                                    <label className={styles.wfLabel}>Кадастровый номер:</label>
                                    <div className={styles.wfInput}>66:59:0102002:657</div>
                                </div>

                                <div className={styles.wfRowTwoCol}>
                                    <div className={styles.wfFormGroup}>
                                        <label className={styles.wfLabel}>Категория:</label>
                                        <div className={styles.wfSelect}>Общая ▾</div>
                                    </div>
                                    <div className={styles.wfFormGroup}>
                                        <label className={styles.wfLabel}>Площадь:</label>
                                        <div className={styles.wfInput}>1 500 м²</div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.wfFooterBtns}>
                                <span className={styles.wfCancelBtn}>Отмена</span>
                                <span className={styles.wfSaveBtn}>Сохранить</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
